/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

var show = console.log.bind( console );
import { Input } from '@angular/core';


export class LayoutBaseComponent {
      
       @Input() id: string;
       
       @Input("outer-class")   class_name:string ="";
       @Input('outer-style')   styleName: any = "";

       @Input('text-class')    textClass: string = "";
       @Input('text-style')    textStyle: string = "";

       @Input('input-class')   input_class: string = "";
       @Input('input-style')   inputStyle: string = "";

       @Input("if")            generalIf:any;

       @Input('label-class')   label_class: string = "";
       @Input('label-style')   labelStyle: string = "";
       @Input("label-param")   labelParam:any;
       @Input("label-if")      labelWhere:any;

       @Input() margin:string;
       @Input() width: string;
       @Input() space: string;
       @Input() label: string;

        protected labelCheck() {

            if ( this.label && this.label.endsWith("$") ) {

                  let  where = this.labelWhere;

                  if ( where === undefined  ) where = this.generalIf;
  
                  if ( where !== undefined  ) {
              
                       if ( typeof where == 'string' ) {
                            if ( where ) this.label += where;
                       }
                       else
                       if ( where )  this.label += "Y";
                       else          this.label += "N";
                  }
             } 
        }

        protected layoutFromViewInit(outbox:any) {

            if ( this.id ) {
                 outbox.id = this.id; 
            }

            //-----------------------------------------------------------------------
            if ( this.width ) {
                  outbox.style.width   = this.width;
                  outbox.style.display = "inline-block";
            }

            //-----------------------------------------------------------------------
            if ( this.space ) {
                  outbox.style.marginRight = this.space +"em";
                  outbox.style.display = "inline-block";
            }

            //-----------------------------------------------------------------------
            if ( this.margin ) {

                 this.margin = this.margin.trim();
                 let style = outbox.style;

                 let idx = this.margin.indexOf(",");
                 if ( idx >= 0 ) {
                      let  value1 = this.margin.substring(0,idx);
                      if ( value1.length > 0  ) this._setMargin(style,value1);
                      let  value2 = this.margin.substring(idx+1);
                      if ( value2.length > 0  ) this._setMargin(style,value2);
                 }
                 else this._setMargin(style,this.margin);
            }
      }

      private _setMargin(style:any,value:string) {

            let value1 = "";
            let value2 = "";

            let  idx = value.indexOf("/");
            if ( idx >= 0 ) {
                 value1 = value.substring(0,idx);
                 value2 = value.substring(idx+1);      
                 if ( value1.length > 0 ) style.marginTop    = value1 + "em";
                 if ( value2.length > 0 ) style.marginBottom = value2 + "em";
            }
            else {
                idx = value.indexOf("|"); 
                if ( idx >= 0 ) {
                     value1 = value.substring(0,idx);
                     value2 = value.substring(idx+1);      
                     if ( value1.length > 0 ) style.marginLeft  = value1 + "em";
                     if ( value2.length > 0 ) style.marginRight = value2 + "em";
                }
                else {
                     style.marginTop    = this.margin +"em";
                     style.marginBottom = this.margin +"em";
                }
            }
   }
}